/*eslint-disable*/
import { useState, useEffect, useRef } from "react";
import { NavLink as NavLinkRRD, Link, useNavigate, Form } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";

// reactstrap components
import {
  Button,
  CardFooter,
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  FormGroup,
  InputGroup,
  InputGroupAddon,  
  InputGroupText,
  Input,
  Media,
  Modal,
  ModalHeader, 
  ModalBody, 
  ModalFooter,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";
import { getUserTokenBPO } from "util/security";
import { toast, ToastContainer } from 'react-toastify'


var ps;

const Sidebar = (props) => {
  const API_URL = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();
  const [collapseOpen, setCollapseOpen] = useState();
  const [user, setUser] = useState(null);

  const [status, setStatus] = useState(null);
  const [info, setInfo] = useState(null);
  const [disabledBtnSenha, setDisabledBtnSenha] = useState(false);
  const [formPasswordData, setFormPasswordData] = useState({password: '', confirmPassword: '', newPassword: ''});
  const passwordRef = useRef(null);

  let logoFoto = "/img/users/" + localStorage.getItem("@ProsperBI:foto");

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  // toggles collapse between opened and closed (true/false)
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  // closes the collapse
  const closeCollapse = () => {
    setCollapseOpen(false);
  };

  useEffect(() => {    
      setUser(getUserTokenBPO());
  }, []);

  useEffect(() => {
    if (status) {
      toast.warn(status);
      setStatus(null);
    }
  }, [status])

  useEffect(() => {
    if (info) {
      toast.info(info);
      setInfo(null);
      clearFormPassword();
    }
  }, [info])

  const clearFormPassword = () => {
    setFormPasswordData({password: '', confirmPassword: '', newPassword: ''});
  }

  const closeFormPassword = () => {
    clearFormPassword();
    setStatus(null);
    setInfo(null);
    setDisabledBtnSenha(false);
    toggleModalSenha();
  }

  // creates the links that appear in the left menu / Sidebar
  const createLinks = (routes) => {
    const adminRoutes = routes[1].children;
    return adminRoutes.map((prop, key) => {
      if ( (prop.path != 'paineis') && (prop.path != 'reports') ) {
        return false;
      }
      return (
        <NavItem key={key}>
          <NavLink
            to={"/admin/" + prop.path}
            tag={NavLinkRRD}
            onClick={closeCollapse}
          >
            <i className={prop.icon} />
            {prop.name}
          </NavLink>
        </NavItem>
      );
    });
  };

  const { bgColor, routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }

  const logout = (event) => {
    event.preventDefault();    
    localStorage.clear();
    return navigate("/");;
  }

  const [modalSenha, setModalSenha] = useState(false);
  const toggleModalSenha = () => setModalSenha(!modalSenha);

  const handleFormPasswordChange = (e) => {
    setFormPasswordData({...formPasswordData, [e.target.name]: e.target.value});
  }   

  const handleFormPasswordSubmit = async (e) => {
    e.preventDefault();

    if (!formPasswordData.password || !formPasswordData.confirmPassword || !formPasswordData.newPassword) {
      setStatus("Todos os campos devem ser preenchidos.");      
      passwordRef.current?.focus(); 
    }
    else if (formPasswordData.newPassword !== formPasswordData.confirmPassword) {
      setStatus("A nova senha e a confirmação da senha não conferem.");      
      passwordRef.current?.focus(); 
    }
    else if (formPasswordData.password === formPasswordData.newPassword) {
      setStatus("A nova senha deve ser diferente da senha atual.");      
      passwordRef.current?.focus(); 
    }
    else {
      try {
        setStatus(null);
        setDisabledBtnSenha(true);
        const response = await fetch(API_URL, {
          method: "POST",
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            name: 'update_password',
            params: {
              username: localStorage.getItem('@ProsperBI:email'),
              password: formPasswordData.password,
              new_password: formPasswordData.newPassword
            }
          })
        })

        if (response.status === 200) {
          const result = await response.json();
          setInfo(result.message);
          toggleModalSenha();
        }
        else {
          setStatus('Erro ao atualizar senha. Verifique se as senhas estão corretas.');
        }        
      }
      catch (error) {
        console.error(error);
        setStatus('Erro ao atualizar senha.');
      }
      finally {
        setDisabledBtnSenha(false);
      }
    }
  }
  
  const [modalETL, setModalETL] = useState(false);
  const toggleModalETL = () => setModalETL(!modalETL);
  const [etlProcessing, setEtlProcessing] = useState(false);  
  const [urlETL, setUrlETL] = useState(null);
  const pollingRef = useRef(null);
  const isRunningRef = useRef(false);

  const handleExecuteETL = async (e) => {
    e.preventDefault();

    try {
      setEtlProcessing(true);
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: 'paineis',
          params: {
            action: "execute_etl"
          }
        })
      });
      
      if (response.ok) {
        const result = await response.json();
        const url_etl = result.message;
        setUrlETL(url_etl);
      }
    }
    catch (error) {
      console.error(error);
      setEtlProcessing(false);
      setStatus('Erro ao executar o ETL.');
    }

  }

  const checkETLStatus = async () => {
    if (isRunningRef.current) return;

    isRunningRef.current = true;

    try {
      if (urlETL) {
        const response = await fetch(API_URL, {
          method: "POST",
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            name: 'paineis',
            params: {
              action: "status_etl",
              url_etl: urlETL
            }
          })
        });
        if (response.ok) {
          const result = await response.json();
          if (result.message === 'Completed') {
            setInfo('ETL concluído com sucesso.');
            setEtlProcessing(false);
            setUrlETL(null);
            isRunningRef.current = false;
            pararPolling();
            toggleModalETL();
          }
        }
      }
    }
    catch (error) {
      console.error(error);
      setEtlProcessing(false);
      setStatus('Erro ao verificar o status do ETL.');
      pararPolling();
    }
    finally {
      isRunningRef.current = false;

      // Agenda próxima verificação
      pollingRef.current = setTimeout(
        () => checkETLStatus(),
        5000 // Verifica a cada 5 segundos
      );
    }
  }

  useEffect(() => {
    if (urlETL) {
      checkETLStatus();
    }
    
    return () => pararPolling();
  }, [urlETL]);

  const pararPolling = () => {
    if (pollingRef.current) {
      clearTimeout(pollingRef.current);
      pollingRef.current = null;
    }
  }

  return (
    <>
      <ToastContainer position="top-right" />
      <Navbar
        className="navbar-vertical fixed-left navbar-light bg-white"
        expand="md"
        id="sidenav-main"
      >
        <Container fluid>
          {/* Toggler */}
          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleCollapse}
          >
            <span className="navbar-toggler-icon" />
          </button>
          {/* Brand */}
          {logo ? (
            <NavbarBrand className="pt-0" {...navbarBrandProps}>
              <img
                alt={logo.imgAlt}
                className="navbar-brand-img"
                src={logo.imgSrc}
              />
            </NavbarBrand>
          ) : null}
          {/* Collapse */}
          <Collapse navbar isOpen={collapseOpen}>
            {/* Collapse header */}
            <div className="navbar-collapse-header d-md-none">
              <Row>
                {logo ? (
                  <Col className="collapse-brand" xs="6">
                    {logo.innerLink ? (
                      <Link to={logo.innerLink}>
                        <img alt={logo.imgAlt} src={logo.imgSrc} />
                      </Link>
                    ) : (
                      <a href={logo.outterLink}>
                        <img alt={logo.imgAlt} src={logo.imgSrc} />
                      </a>
                    )}
                  </Col>
                ) : null}
                <Col className="collapse-close" xs="6">
                  <button
                    className="navbar-toggler"
                    type="button"
                    onClick={toggleCollapse}
                  >
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
            {/* Navegação */}
            <Nav navbar>{createLinks(routes)}</Nav>
            {/* Divider */}
            <hr className="my-3" />
            <Nav className="mb-md-3" navbar>
              <NavItem className="active-pro active">
                <UncontrolledDropdown nav>
                  <DropdownToggle className="pr-0" nav>
                    <Media className="align-items-center">
                      <span className="avatar avatar-sm rounded-circle">
                        <img
                          alt="..."
                          src={logoFoto}
                        />
                      </span>
                      <Media className="ml-2 d-none d-lg-block">
                        <span className="mb-0 text-sm font-weight-bold">
                          {user ? user.username : "Desconhecido"}
                        </span>
                      </Media>
                    </Media>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-arrow" right>
                    <DropdownItem className="noti-title" header tag="div">
                      <h6 className="text-overflow m-0">BEM-VINDO</h6>
                    </DropdownItem>
                    <DropdownItem tag={Link} onClick={() => toggleModalSenha()}>
                      <i className="ni ni-single-02" />
                      <span>Alterar Senha</span>
                    </DropdownItem>
                    <DropdownItem tag={Link} onClick={() => toggleModalETL()}>
                      <i className="ni ni-settings-gear-65" />
                      <span>Carga de Dados</span>
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem onClick={(event) => logout(event) }>
                      <i className="ni ni-user-run" />
                      <span>Sair</span>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>

      <Modal isOpen={modalSenha} toggle={toggleModalSenha}>
        <Form method="post" onSubmit={handleFormPasswordSubmit}>
          <ModalHeader toggle={toggleModalSenha}>ALTERAR SENHA</ModalHeader>
          <ModalBody>          
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Senha Atual"
                    name="password"
                    value={formPasswordData.password}
                    onChange={handleFormPasswordChange}
                    type="password"
                    innerRef={passwordRef}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-air-baloon" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Nova Senha"
                    name="newPassword"
                    type="password"
                    value={formPasswordData.newPassword}
                    onChange={handleFormPasswordChange}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-check-bold" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Confirmação"
                    name="confirmPassword"
                    type="password"
                    value={formPasswordData.confirmPassword}
                    onChange={handleFormPasswordChange}
                  />
                </InputGroup>
              </FormGroup>              
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={disabledBtnSenha}>
              Atualizar Senha
            </Button>
            <Button color="secondary" onClick={closeFormPassword}>
              Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>


      <Modal isOpen={modalETL} toggle={toggleModalETL}>
          <ModalHeader toggle={toggleModalETL}>EXECUTAR ETL</ModalHeader>
          <ModalBody>    
              <spam className="py-4 text-center fw-bold">
                A execução do ETL pode levar alguns minutos.<br/>
                Ao iniciar o processo, não feche esta janela até que a operação seja concluída.
              </spam>           
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={etlProcessing} onClick={handleExecuteETL}>
              Executar ETL
            </Button>
            <Button color="secondary" onClick={toggleModalETL}>
              Cancelar
            </Button>
              {etlProcessing && (
              <CardFooter className="py-4 text-center">
                <span className="mb-0 text-sm text-primary fw-bold">
                  Executando o ETL, aguarde...
                </span>                  
              </CardFooter>
            )}           
          </ModalFooter>
      </Modal>
    </>  
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
